import { API } from 'utils/api/api'
import { formatRequestString } from 'utils/helpers/api/queryString'
import { GetDataSystemsSummaryParams, SystemsSummary } from '@ketch-com/windlass/dist/dataSentry/v1/systems/systems'

export const fetchSystemsSummary = ({
  'start-date': startDate,
  'end-date': endDate,
  'property-codes': propertyCode,
}: GetDataSystemsSummaryParams) =>
  API.get<SystemsSummary>(
    formatRequestString({
      entityUrl: `/api/v1/data-sentry/systems/summary`,
      params: {
        filters: {
          'start-date': startDate,
          'end-date': endDate,
          'property-codes': propertyCode,
        },
      },
    }),
  )
